import { FilterMultiSelect } from "@/components/common/FilterMultiSelect";
import { useHotel } from "@/hooks/useHotel";
import { useRooms } from "@/hooks/useRooms";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export interface RoomFilterProps {
  ids: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

const RoomFilter: React.FC<RoomFilterProps> = ({
  ids,
  onChange,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string[]>(ids || []);

  const { hotelId } = useHotel();
  const { data: roomsData } = useRooms(hotelId!, null, null);

  const handleChange = (ids: string[]) => {
    setSelected(ids);
    onChange(ids);
  };

  return (
    <FilterMultiSelect
      className="w-[200px] justify-between"
      options={
        roomsData?.data
          ? roomsData.data.map((room) => ({
              value: room.id,
              label: `${room.number}`,
            }))
          : []
      }
      placeholder={
        placeholder ?? t("feedbacks.filters.room", "Filter feedbacks by rooms")
      }
      value={selected}
      onValueChange={handleChange}
    />
  );
};

export default RoomFilter;
